module.exports = __webpack_public_path__ + "static/media/Decisions_Step5_Image5.e0015082.webp";